import imageProduct1 from '../assets/images/Shirts/shirtimg1.jpg'
import imageProduct2 from "../assets/images/Shirts/shirtimg2.jpg";
import imageProduct3 from "../assets/images/Shirts/shirtimg3.jpg";

export const products = [
    {
        id: 1,
        name: "The Iron Grey",
        price: 2099,
        image: imageProduct1,
        description: 'Mollit anim consectetur adipisicing aute pariatur ad mollit ad. Officia amet aliqua non laborum dolore sint sit eu sit sunt laboris. Dolor tempor ipsum culpa Lorem ipsum ullamco ullamco dolor sit do. Do proident quis ad laborum et proident laborum. Non voluptate eiusmod aute labore ea aute.',
        slug: 'hertfoid-upholstered-chair'
    },
    {
        id: 2,
        name: "The Soft Green",
        price: 2099,
        image: imageProduct2,
        description: 'Mollit anim consectetur adipisicing aute pariatur ad mollit ad. Officia amet aliqua non laborum dolore sint sit eu sit sunt laboris. Dolor tempor ipsum culpa Lorem ipsum ullamco ullamco dolor sit do. Do proident quis ad laborum et proident laborum. Non voluptate eiusmod aute labore ea aute.',
        slug: 'bingdon-pholstered-chair-swivel'
    },
    {
        id: 3,
        name: "The Olive Green",
        price: 2099,
        image: imageProduct3,
        description: 'Mollit anim consectetur adipisicing aute pariatur ad mollit ad. Officia amet aliqua non laborum dolore sint sit eu sit sunt laboris. Dolor tempor ipsum culpa Lorem ipsum ullamco ullamco dolor sit do. Do proident quis ad laborum et proident laborum. Non voluptate eiusmod aute labore ea aute.',
        slug: 'jeses-minimore-modern-style-etta'
    },
]    